import axios from "axios";
import { createContext, useContext, useEffect, useState, useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

const AuthCtx = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try { setUser((await api.get("/auth/me")).data); }
    catch { try { await api.post("/auth/refresh"); setUser((await api.get("/auth/me")).data); } catch { setUser(false); } }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { await api.post("/auth/logout"); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}
export const useAuth = () => useContext(AuthCtx);

export async function startCheckout(payload) {
  const { data } = await api.post("/payments/checkout", { ...payload, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}
